export default function ProjectCardPresentation({
  contextLabel,
  headingLevel: Heading = "h3",
  logo,
  title,
}) {
  return (
    <div className="av-project-card-presentation">
      <div className="av-project-card-presentation__text">
        <Heading>{title}</Heading>
        {contextLabel ? (
          <p className="av-project-card-presentation__context">{contextLabel}</p>
        ) : null}
      </div>
      {logo ? (
        <div className="av-project-card-presentation__external-brand">
          <img alt="" src={logo} />
        </div>
      ) : null}
    </div>
  );
}
